import React, { useContext } from "react";
import { VideoContext } from "../../context/video_context";
import {
  Box,
  FormControlLabel,
  FormGroup,
  Grid,
  Switch,
  TextField,
  Typography,
} from "@mui/material";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import ToggleButton from "@mui/material/ToggleButton";

export default function TestOptions() {
  const videoContext = useContext(VideoContext);
  const selectedVideo = videoContext?.selectedVideo;
  const titles = videoContext?.titles || [];
  const setTitles = videoContext?.setTitles || (() => {});
  const files = videoContext?.files || [];
  const tests = videoContext?.tests || [];
  const loading = videoContext?.loading || false;
  const useOriginal = videoContext?.useOriginal || false;
  const setUseOriginal = videoContext?.setUseOriginal || (() => {});
  const alignment = videoContext?.alignment || null;
  const setAlignment = videoContext?.setAlignment || (() => {});
  const duration = videoContext?.duration || 0;
  const createTest = videoContext?.createTest || (() => Promise.resolve({}));
  const handleAlignment = (
    event: React.MouseEvent<HTMLElement>,
    newAlignment: string | null,
  ) => {
    setAlignment(newAlignment);
  };
  return (
    <Box>
      <Grid
        container
        spacing={2}
        sx={{
          justifyItems: "center",
          paddingLeft: "auto",
          paddingY: 2,
        }}
      >
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={"IOT"}
          sx={{ minWidth: "326px", fontSize: "h5.fontSize" }}
        >
          <Box sx={{ fontSize: "h5.fontSize" }}>Include original thumbnail</Box>
          <FormGroup sx={{ fontSize: "h5.fontSize" }}>
            <FormControlLabel
              control={
                <Switch
                  defaultChecked
                  value={useOriginal}
                  onChange={(e) => setUseOriginal(e.target.checked)}
                  sx={{ fontSize: "h5.fontSize" }}
                />
              }
              label=""
            />
          </FormGroup>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          lg={3}
          key={"IOT"}
          sx={{ minWidth: "326px" }}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              justifyItems: "center",
              paddingLeft: "auto",
            }}
          >
            <Box sx={{ fontSize: "h5.fontSize", paddingBottom: 1 }}>
              Thumbnail Change Frequency
            </Box>
            <ToggleButtonGroup
              value={alignment}
              exclusive
              onChange={handleAlignment}
              aria-label="Thumbnail Change Freqeuncy"
              size="small"
            >
              <ToggleButton
                className={"Mui-selected:bg-red-500"}
                value="1min"
                aria-label="1 Minute"
              >
                1 Min
              </ToggleButton>
              <ToggleButton value="5min" aria-label="5 Minutes">
                5 Min
              </ToggleButton>
              <ToggleButton value="1hour" aria-label="1 Hour">
                1 Hour
              </ToggleButton>
              <ToggleButton value="6hours" aria-label="6 Hours">
                6 Hours
              </ToggleButton>
              <ToggleButton value="1day" aria-label="1 Day">
                1 Day
              </ToggleButton>
              <ToggleButton value="1week" aria-label="1 Week">
                1 Week
              </ToggleButton>
            </ToggleButtonGroup>
          </Box>
        </Grid>
      </Grid>
      {/*<Box>
        <Box sx={{ fontSize: "h5.fontSize", paddingY: "20px" }}>
          Test Duration
        </Box>
        <Box
          sx={{
            alignContent: "center",
            display: "flex",
            flexDirection: "row",
          }}
        >
          <Typography sx={{ alignContent: "center", marginRight: "4px" }}>
            {"Test will run for: "}
          </Typography>
          <TextField
            id="outlined-number"
            label="Test Duration"
            type="number"
            InputLabelProps={{
              shrink: true,
            }}
            size={"small"}
          />
          <Typography sx={{ alignContent: "center", marginLeft: "4px" }}>
            {alignment == "1min" || alignment == "5min" ? "minutes" : 
             alignment == "1hour" || alignment == "6hours" ? "hours" : 
             alignment == "1day" ? "days" : "weeks"}
          </Typography>
        </Box>
      </Box> */}
    </Box>
  );
}
